import { Button, Image, Input, Select } from "@chakra-ui/react";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
`;
export const ContainerImagemProduto = styled.div`
  background-color: #313131;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
    font-family: "Akrobat";
  }
`;
export const Modal = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 868px;
  position: fixed;
  z-index: 999999;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.151);
`;
export const ModalContent = styled.div`
  width: 1000px;
  height: 100%;
  z-index: 999999;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
`;
export const ModalContentCard = styled.div`
  width: 95%;
  height: 80%;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ModalContentCardLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.378);
  border-radius: 10px;
  z-index: 99999;
  display: flex;
  align-items: center;
`;
export const ModalContentCardLoadingContent = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ImageLoading = styled(Image)``;
export const ModalContentCardHeader = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
`;
export const ModalContentCardHeaderContent = styled.div`
  width: 80%;
  height: 100%;
  position: relative;
  border-bottom: 0.3px solid rgba(61, 61, 61, 0.212);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    font-size: 20px;
    font-family: "Akrobat";
    letter-spacing: 0.06rem;
    color: rgb(61, 61, 61);
    font-weight: bold;
  }
`;
export const ButtonModal = styled(Button)`
  width: 100px;
  height: 100%;
  font-family: "Akrobat";
  font-size: 16px;
  border: none;
`;
export const ModalContentCardBody = styled.div`
  width: 100%;
  height: 80%;
  min-height: 459px;
  margin-top: 15px;
  overflow-y: scroll;
`;
export const ModalContentCardBodyCardProd = styled.div`
  width: 80%;
  height: 200px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ModalContentCardBodyCardProdBoxImage = styled.div`
  width: 180px;
  height: 190px;
  position: relative;
  float: left;
  margin: 5px;
  border: 0.6px solid rgb(61, 61, 61);
`;
export const ImageModalContentBody = styled(Image)`
  width: 100%;
  height: 190px;
  display: flex;
  object-fit: cover;
`;
export const ModalContentCardBodyCardProdBoxDesc = styled.div`
  width: 500px;
  height: 180px;
  position: relative;
  float: left;
  margin: 5px;
  margin-left: 15px;
  border: 5px solid rgb(245, 245, 245);
  background-color: rgb(245, 245, 245);
  p {
    color: rgb(61, 61, 61);
  }
`;
export const ModalContentCardBodyCardProdSearch = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  height: 50px;
`;
export const CardFieldSearch = styled.div`
  width: 90%;
  height: 35px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const InputSearch = styled(Input)`
  width: 40%;
  height: 30px;
  margin-left: 10px;
`;
export const ButtonSearch = styled(Button)`
  border: none;
  font-family: "Akrobat ExtraBold", sans-serif;
  letter-spacing: 0.06rem;
  margin-left: 10px;
  border-radius: 3px;
  font-size: 14px;
  color: white;
`;
export const ModalContentBodyCardFields = styled.div`
  width: 80%;
  height: 420px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ModalContentBodyCardFieldsField = styled.div`
  width: 90%;
  height: 35px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  label {
    width: 23.5%;
    color: rgb(61, 61, 61);
    font-family: "Akrobat";
    font-size: 16px;
    text-align: right;
  }
`;
export const ModalContentBodyCardFieldsFieldInputFile = styled.div`
  width: 76.5%;
  height: 100%;
  position: relative;
  margin-left: 10px;
  cursor: pointer;
`;
export const InputModal = styled(Input)`
  height: 100%;
  font-family: "Akrobat";
  font-size: 14px;
  color: rgb(0, 0, 0);
  ::-webkit-file-upload-button {
    width: 200px;
    height: 2.2rem;
    border: none;
    font-family: "Akrobat";
    letter-spacing: 0.06rem;
    font-size: 14px;
    color: white;
    cursor: pointer;
    border-radius: 3px;
    background-color: #313131;
  }
`;
export const ModalContentBodyCardFieldsFieldCustom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 200px;
    height: 30px;
    border: none;
    font-family: "Akrobat";
    font-size: 14px;
    letter-spacing: 0.06rem;
    color: white;
    background-color: #313131;
    position: relative;
    margin-left: 15px;
    cursor: pointer;
  }
`;
export const ModalContainerCardFooter = styled.div`
  width: 100%;
  height: 50px;
`;
export const ModalContainerCardFooterControl = styled.div`
  width: 90%;
  height: 35px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  // background-color: slateblue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    width: 200px;
    height: 30px;
    border: none;
    font-family: "Akrobat";
    font-size: 14px;
    letter-spacing: 0.06rem;
    color: white;
    background-color: #313131;
    position: relative;
  }

  label {
    width: 70%;
    // height: 100%;
    color: rgb(61, 61, 61);
    font-family: "Akrobat";
    font-size: 16px;
    text-align: right;
  }
`;
export const ContentFilter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
  margin-bottom: 20px;
`;
export const ContentFilterSelectFolder = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
`;
export const ContentFilterAddFolder = styled.div`
  display: flex;
  align-items: center;
  font-family: Akrobat;
  margin-left: 10px;
  margin-right: 10px;
  label {
    height: 30px;
    position: relative;
    color: rgb(61, 61, 61);
    font-family: Akrobat ExtraBold;
    float: left;
    display: flex;
    align-items: center;
    font-size: 16px;
    strong {
      position: relative;
      left: 10px;
      font-size: 20px;
      font-family: "Akrobat ExtraBold";
    }
  }
  button {
    width: 40px;
    height: 40px;
    border: none;
    background-color: #313131;
    margin-left: 10px;
    border-radius: 30px;
    cursor: pointer;
    h1 {
      &:hover {
        font-size: 38px;
        top: -11px;
        transition: 0.2s;
        transform: scale(1.1, 1.1);
      }
      font-family: "Akrobat SemiBold";
      font-size: 35px;
      color: white;
      position: relative;
      top: -9px;
    }
  }
`;
export const ContentFilterSelectSystem = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  label {
    // width: 100px;
    height: 30px;
    position: relative;
    color: rgb(61, 61, 61);
    font-family: "Akrobat Extrabold";
    float: left;
    display: flex;
    align-items: center;
    font-size: 16px;
    strong {
      position: relative;
      left: 10px;
      font-size: 20px;
      font-family: "Akrobat ExtraBold";
    }
  }
  `;
  export const SelectSistema = styled(Select) `  
    width: 150px;
    height: 30px;
    border: 0.4px solid rgba(0, 0, 0, 0.322);
    margin-left: 5px;
    font-size: 14px;
    font-family: "Akrobat";
    outline: none;
    color: rgb(61, 61, 61);
  `;
  
export const ContentTables = styled.div``;
export const ContentTablesGrid = styled.div`
  width: 95%;
  min-height: 350px;
  position: relative;
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
  // background-color: #fdb913;
  flex-direction: row;
`;
export const ContentTablesGridCard = styled.div`
  width: 90px;
  height: 80px;
  position: relative;
  float: left;
  margin-left: 30px;
  margin-top: 25px;
  text-align: center;
  p {
    font-size: 18px;
  }

  img:hover {
    transition: 0.4s;
    transform: scale(1.1, 1.1);
    cursor: pointer;
  }
`;
